'use client';

import { usePathname, useSearchParams } from 'next/navigation';

/**
 * 現在のURL（パス + クエリパラメータ）を取得するカスタムフック
 */
export const useCurrentPathname = (): string => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
};
